<template>
  <div class="cashflow-type-excluded card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>
    <predicted-category-sections v-if="hasExcludedIncome"
                                 :actuals-title="titles.categorySections.income.actualsTitle"
                                 :expense-category="'הכנסות'"
                                 :categories="transactions.excludedIncome.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="false"
                                 :title="titles.categorySections.income.mainTitle"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction-row class="transaction-details"
                           v-for="transaction in transactions"
                           :transaction="transaction"
                           :can-edit-category="true"
                           :category-name="categoryNameExcludedIncome"
                           v-bind:key="transaction.transactionId">
          </transaction-row>
        </div>
      </template>
    </predicted-category-sections>

    <predicted-category-sections v-if="hasExcludedExpense"
                                 :actuals-title="titles.categorySections.expense.actualsTitle"
                                 :recommended-title="titles.categorySections.expense.recommendedTitle"
                                 :expense-category="'הוצאות'"
                                 :categories="transactions.excludedExpense.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="false"
                                 :title="titles.categorySections.expense.mainTitle"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction-row class="transaction-details"
                           v-for="transaction in transactions"
                           :transaction="transaction"
                           :can-edit-category="true"
                           :category-name="categoryNameExcludedExpense"
                           v-bind:key="transaction.transactionId">
          </transaction-row>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import TransactionRow from '../../../generic-components/cashflow-types/cashflow-types-base/TransactionRow.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';


export default {
  name: 'CashflowTypeExcluded',
  mixins: [CashflowAnalytics],
  components: {
    TransactionRow,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.excluded;
    },
    transactions() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    hasExcludedExpense() {
      return _.sumBy(this.transactions.excludedExpense.categories, c => c.transactions.length) > 0;
    },
    hasExcludedIncome() {
      return _.sumBy(this.transactions.excludedIncome.categories, c => c.transactions.length) > 0;
    },
    categoryNameExcludedExpense() {
      return cashflowViewConsts.CATEGORY_NAMES.EXCLUDED_EXPENSE;
    },
    categoryNameExcludedIncome() {
      return cashflowViewConsts.CATEGORY_NAMES.EXCLUDED_INCOME;
    },
    titles() {
      return {
        categorySections: {
          income: {
            actualsTitle: 'הוחרגו מהתזרים',
            mainTitle: 'פירוט הכנסות לא תזרימיות',
          },
          expense: {
            actualsTitle: 'הוחרגו מהתזרים',
            mainTitle: 'פירוט הוצאות לא תזרימיות',
          },
        },
        cardTitle: 'לא בתזרים',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-excluded {
    @include cashflow-card;

    .title {
      @include cashflow-card-title;
    }

    .cashflow-type-color {
      color: $riseup_gray_1;
    }

    .cashflow-type-background-color {
      background-color: $riseup_gray_1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/types/CashflowTypeExcluded.vue